'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var React = require('react');
var reactHookForm = require('react-hook-form');
var useFormieSubmit = require('../../lib/useFormieSubmit.js');
var FormieRows = require('../FormieRows/FormieRows.js');
var FormSubmitRow = require('../FormSubmitRow/FormSubmitRow.js');
require('../Recaptcha/googleRecaptchaVerify.js');
var RecaptchaPolicy = require('../Recaptcha/RecaptchaPolicy.js');
require('react-google-recaptcha-v3');
var useFormieGRecaptcha = require('../Recaptcha/useFormieGRecaptcha.js');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const Formie = (props)=>{
    var _form_settings, _form_settings1;
    const { form, gRecaptchaSettings, showGRecaptchaPolicy, defaultValues } = props;
    const methods = reactHookForm.useForm({
        mode: 'onChange',
        defaultValues
    });
    const { getCaptchaValues } = useFormieGRecaptcha(gRecaptchaSettings);
    const { triggerSubmit, isSuccess, isError, isLoading, errors } = useFormieSubmit();
    const onSubmit = React.useCallback(async (values)=>{
        if (!form || !form.uid) return;
        var _form_submissionMutationName;
        const mutationName = (_form_submissionMutationName = form.submissionMutationName) != null ? _form_submissionMutationName : '';
        const captchaValues = getCaptchaValues ? await getCaptchaValues() : {};
        triggerSubmit(mutationName, _extends({}, values, captchaValues), form.uid);
    }, [
        form,
        getCaptchaValues,
        triggerSubmit
    ]);
    // -----------------------------------------------------------------------------------
    // ---- Errors ----
    React.useEffect(()=>{
        methods.clearErrors();
        Object.entries(errors != null ? errors : {}).forEach(([key, value])=>{
            methods.setError(key, {
                type: 'manual',
                message: value.join(', ')
            });
        });
    }, [
        errors,
        methods
    ]);
    var _form_settings_errorMessageHtml, _form_settings_submitActionMessageHtml;
    // -----------------------------------------------------------------------------------
    return /*#__PURE__*/ jsxRuntime.jsxs("form", {
        noValidate: true,
        onSubmit: methods.handleSubmit(onSubmit),
        children: [
            /*#__PURE__*/ jsxRuntime.jsx(FormieRows, {
                data: form == null ? void 0 : form.rows,
                methods: methods
            }),
            /*#__PURE__*/ jsxRuntime.jsx(FormSubmitRow, {
                isSuccess,
                isError: isError && !methods.formState.isValid,
                isLoading: isLoading || methods.formState.isSubmitting,
                messages: {
                    error: (_form_settings_errorMessageHtml = form == null ? void 0 : (_form_settings = form.settings) == null ? void 0 : _form_settings.errorMessageHtml) != null ? _form_settings_errorMessageHtml : 'An error occurred',
                    success: (_form_settings_submitActionMessageHtml = form == null ? void 0 : (_form_settings1 = form.settings) == null ? void 0 : _form_settings1.submitActionMessageHtml) != null ? _form_settings_submitActionMessageHtml : 'Submitted'
                }
            }),
            showGRecaptchaPolicy && /*#__PURE__*/ jsxRuntime.jsx(RecaptchaPolicy, {
                marginTop: 2,
                color: "grey",
                variant: "body2"
            })
        ]
    });
};

module.exports = Formie;
